/* LOOKEE® product page sections, no libraries: Product videos [data-vd], Setup guide [data-gd], Product info tabs
   [data-pi], Banner [data-bn], Scrolling ribbon [data-tk], and the Copy button [data-copy].
   Every section starts again when the theme editor reloads it, and follows block selection in the editor.
   Motion stops with the footer switch (html[data-motion="off"]) and the system's reduced-motion setting. */
(function () {
  'use strict';
  if (window.__lkPdp) return;
  window.__lkPdp = 1;
  var html = document.documentElement;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function still() { return html.getAttribute('data-motion') === 'off' || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function design() { return !!(window.Shopify && window.Shopify.designMode); }
  function seen(el, fn, threshold) {
    if (!('IntersectionObserver' in window)) { fn(true); return null; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { fn(e.isIntersecting); }); }, { threshold: threshold || 0.35 });
    io.observe(el);
    return io;
  }

  /* -------------------------------------------------------------------------------------------------
     1. Product videos. The screen shows the chosen video's still (gently moving) and a Play button.
        file: a <video> with its own controls; embed: a YouTube or Vimeo player; demo (or a file that is
        not uploaded yet): the moving preview from the block's pictures and lines, with its own timeline.
  ------------------------------------------------------------------------------------------------- */
  var DEMO_STEP = 3600;
  function initVideos(root) {
    if (root.__vd) return; root.__vd = 1;
    var screen = $('[data-vd-screen]', root), stage = $('[data-vd-stage]', root), play = $('[data-vd-play]', root);
    var playTitle = $('[data-vd-play-title]', root), playLen = $('[data-vd-play-len]', root);
    var nowBox = $('.vd__now', root), nowTitle = $('[data-vd-now-title]', root), nowText = $('[data-vd-now-text]', root);
    var pauseBtn = $('[data-vd-pause]', root), closeBtn = $('[data-vd-close]', root), tag = $('[data-vd-tag]', root);
    var items = $$('[data-vd-item]', root);
    if (!items.length) return;
    var cur = 0, media = null, raf = 0, demo = null, loopV = null, inView = false;
    var autoNext = root.hasAttribute('data-vd-next'), inEditor = root.hasAttribute('data-vd-design');

    function setP(p) { screen.style.setProperty('--p', p); if (items[cur]) items[cur].style.setProperty('--p', p); }
    function info(i) {
      var it = items[i], li = it.parentNode;
      return { kind: it.getAttribute('data-kind'), src: it.getAttribute('data-src'), poster: it.getAttribute('data-poster'), loop: it.getAttribute('data-loop'),
        title: ($('[data-vd-title]', it) || {}).textContent || '', len: ($('[data-vd-len]', it) || {}).textContent || '',
        text: $('template[data-vd-text]', li), demo: $('template[data-vd-demo]', li) };
    }
    // The silent moving background: starts only while the screen is in view and nothing is playing, never on Data Saver.
    function stopLoop() {
      if (!loopV) return;
      try { loopV.pause(); } catch (e) {}
      loopV.removeAttribute('src');
      try { loopV.load(); } catch (e) {}
      if (loopV.parentNode) loopV.parentNode.removeChild(loopV);
      loopV = null;
    }
    function startLoop() {
      var d = info(cur), net = navigator.connection;
      if (!d.loop || !inView || media || demo || loopV || still() || (net && (net.saveData || /2g|3g/.test(net.effectiveType || '')))) return;
      var v = document.createElement('video');
      v.className = 'vd__loop'; v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'metadata';
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
      v.addEventListener('error', stopLoop, { once: true });
      v.src = d.loop;
      stage.appendChild(v); loopV = v;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function stopAll() {
      cancelAnimationFrame(raf);
      stopLoop();
      if (demo) { clearTimeout(demo.t); demo = null; }
      if (media && media.tagName === 'VIDEO') { try { media.pause(); } catch (e) {} media.removeAttribute('src'); try { media.load(); } catch (e) {} }
      media = null;
      root.classList.remove('is-playing', 'is-paused', 'is-file', 'is-embed', 'is-demo');
    }
    function showPoster(i) {
      var d = info(i);
      stage.innerHTML = '';
      if (d.poster) {
        var f = document.createElement('div'); f.className = 'vd__poster';
        var im = new Image(); im.alt = ''; im.decoding = 'async'; im.loading = 'lazy'; im.src = window.innerWidth < 1000 ? d.poster : d.poster.replace('width=960', 'width=1280');
        f.appendChild(im); stage.appendChild(f);
      } else if (d.demo) {
        stage.appendChild(d.demo.content.cloneNode(true));
        var first = $('.vdp__f', stage); if (first) first.classList.add('is-on');
      }
      playTitle.textContent = d.title;
      playLen.textContent = d.len;
      play.setAttribute('aria-label', 'Play: ' + d.title + (d.len ? ', ' + d.len : ''));
      if (tag) tag.hidden = !(inEditor && d.kind === 'demo');
      startLoop();
    }
    function setNow(i, swap) {
      var d = info(i);
      nowTitle.textContent = d.title;
      nowText.innerHTML = d.text ? d.text.innerHTML : '';
      if (swap && !still()) { nowBox.classList.remove('is-swap'); void nowBox.offsetWidth; nowBox.classList.add('is-swap'); }
    }
    function select(i, start) {
      stopAll(); setP(0);
      items.forEach(function (it, k) { if (k === i) it.setAttribute('aria-current', 'true'); else it.removeAttribute('aria-current'); it.style.setProperty('--p', 0); });
      cur = i;
      showPoster(i); setNow(i, true);
      if (start) begin();
    }
    function ended() {
      setP(1);
      if (autoNext && cur < items.length - 1) select(cur + 1, true);
      else { stopAll(); showPoster(cur); }
    }
    function runDemo(fromFile) {
      var d = info(cur);
      if (!d.demo) { stopAll(); showPoster(cur); return; }
      stage.innerHTML = '';
      stage.appendChild(d.demo.content.cloneNode(true));
      var frames = $$('.vdp__f', stage), lines = $$('.vdp__line', stage);
      var steps = Math.max(frames.length, lines.length, 3), total = steps * DEMO_STEP, t0 = performance.now(), k = -1;
      root.classList.remove('is-file', 'is-embed');
      root.classList.add('is-playing', 'is-demo');
      if (tag) { tag.hidden = !inEditor; tag.textContent = fromFile ? 'Demo: video file not found' : 'Demo'; }
      demo = { paused: false, at: 0 };
      function show(n) {
        frames.forEach(function (f, j) { f.classList.toggle('is-on', j === n % frames.length); });
        lines.forEach(function (l, j) { l.classList.toggle('is-on', j === n % Math.max(lines.length, 1) && n < steps); });
      }
      function tick(now) {
        if (!demo) return;
        if (demo.paused) { t0 = now - demo.at; raf = requestAnimationFrame(tick); return; }
        var el = now - t0; demo.at = el;
        var n = Math.min(steps - 1, Math.floor(el / DEMO_STEP));
        if (n !== k) { k = n; show(n); }
        setP(Math.min(1, el / total));
        if (el >= total) { ended(); return; }
        raf = requestAnimationFrame(tick);
      }
      if (still()) { show(0); lines.forEach(function (l) { l.classList.add('is-on'); }); setP(1); return; }
      raf = requestAnimationFrame(tick);
    }
    function begin() {
      var d = info(cur);
      stopLoop();
      if (d.kind === 'file' && d.src) {
        stage.innerHTML = '';
        var v = document.createElement('video');
        v.controls = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.preload = 'auto';
        if (d.poster) v.poster = d.poster;
        v.src = d.src;
        v.addEventListener('timeupdate', function () { if (v.duration) setP(v.currentTime / v.duration); });
        v.addEventListener('ended', ended);
        v.addEventListener('error', function () { if (media === v) { media = null; runDemo(true); } });
        stage.appendChild(v); media = v;
        root.classList.add('is-playing', 'is-file');
        if (tag) tag.hidden = true;
        var pr = v.play();
        // a browser that refuses sound still plays the film muted (the films are silent anyway)
        if (pr && pr.catch) pr.catch(function () { v.muted = true; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); });
        v.focus({ preventScroll: true });
      } else if (d.kind === 'embed' && d.src) {
        stage.innerHTML = '';
        var f = document.createElement('iframe');
        f.src = d.src; f.title = d.title; f.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media'; f.allowFullscreen = true;
        f.referrerPolicy = 'strict-origin-when-cross-origin';
        stage.appendChild(f); media = f;
        root.classList.add('is-playing', 'is-embed');
        if (tag) tag.hidden = true;
      } else runDemo(false);
    }

    play.addEventListener('click', begin);
    items.forEach(function (it, i) { it.addEventListener('click', function () { select(i, true); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      if (!demo) return;
      demo.paused = !demo.paused;
      root.classList.toggle('is-paused', demo.paused);
      pauseBtn.setAttribute('aria-label', demo.paused ? 'Play' : 'Pause');
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { stopAll(); setP(0); showPoster(cur); play.focus(); });
    // a video that scrolls far out of view stops, so sound never plays from an unseen screen
    seen(root, function (vis) { if (!vis && media && media.tagName === 'VIDEO' && !media.paused) media.pause(); }, 0);
    seen(screen, function (vis) {
      inView = vis;
      if (!vis) { if (loopV) loopV.pause(); return; }
      if (loopV) { var p = loopV.play(); if (p && p.catch) p.catch(function () {}); } else startLoop();
    }, 0.25);

    root.__select = function (blockId) { items.forEach(function (it, i) { if (it.getAttribute('data-block') === blockId) select(i, false); }); };
    select(0, false);
  }

  /* -------------------------------------------------------------------------------------------------
     2. Setup guide. One step open at a time; earlier steps tick off; the stage shows the open step's
        picture (or the nearest earlier one), and plays its silent loop. Plays once by itself on view.
  ------------------------------------------------------------------------------------------------- */
  var GUIDE_STEP = 6000;
  function initGuide(root) {
    if (root.__gd) return; root.__gd = 1;
    var steps = $$('[data-gd-step]', root), frames = $$('[data-gd-frame]', root);
    var prev = $('[data-gd-prev]', root), next = $('[data-gd-next]', root), count = $('[data-gd-count]', root);
    var big = $('[data-gd-big]', root), dots = $$('.gd__dots i', root), done = $('[data-gd-done]', root), again = $('[data-gd-again]', root);
    var burst = $('[data-gd-burst]', root);
    if (!steps.length) return;
    var cur = 0, finished = false, timer = 0, auto = root.hasAttribute('data-gd-auto') && !still() && !design();
    root.style.setProperty('--gd-dur', GUIDE_STEP + 'ms');

    function frameFor(i) {
      for (var k = i; k >= 0; k--) { var f = $('[data-gd-frame="' + k + '"]', root); if (f) return f; }
      return $('[data-gd-frame="fallback"]', root) || $('[data-gd-frame]', root);
    }
    function loadVideo(f) {
      var v = $('video[data-gd-video]', f);
      if (!v || still()) return;
      if (!v.src) {
        v.src = v.getAttribute('data-src');
        v.addEventListener('canplay', function () { v.classList.add('is-ready'); }, { once: true });
        v.addEventListener('error', function () { v.remove(); }, { once: true });
      }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function go(i, user) {
      if (user) stopAuto();
      i = Math.max(0, Math.min(steps.length - 1, i));
      var changed = i !== cur; cur = i;
      steps.forEach(function (s, k) {
        s.classList.toggle('is-on', k === cur);
        s.classList.toggle('is-done', k < cur || finished);
        $('.gd__btn', s).setAttribute('aria-expanded', k === cur ? 'true' : 'false');
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); d.classList.toggle('is-done', k < cur || finished); });
      var fr = frameFor(cur);
      frames.forEach(function (f) {
        var on = f === fr; f.classList.toggle('is-on', on);
        var v = $('video', f); if (v && !on && !v.paused) v.pause();
      });
      if (fr && root.__visible) loadVideo(fr);
      if (big) { big.textContent = cur + 1; big.style.setProperty('--gp', ((cur + 1) / steps.length).toFixed(3)); if (changed && !still()) { big.classList.remove('is-swap'); void big.offsetWidth; big.classList.add('is-swap'); } }
      count.textContent = (cur + 1) + ' / ' + steps.length;
      prev.disabled = cur === 0;
      next.textContent = cur === steps.length - 1 ? next.getAttribute('data-last') : next.getAttribute('data-label');
      if (auto && root.classList.contains('is-auto')) {
        // restart the running line under the open step
        var run = $('.gd__run', steps[cur]); if (run) { run.style.animation = 'none'; void run.offsetWidth; run.style.animation = ''; }
      }
    }
    function pop() {
      if (!burst || still()) return;
      var colors = ['#fe5000', '#5b6770', '#a5a7bc', '#8f91b0', '#fe5000'];
      burst.innerHTML = '';
      for (var k = 0; k < 28; k++) {
        var i = document.createElement('i'), a = (k / 28) * Math.PI * 2 + Math.random() * .4, r = 120 + Math.random() * 180;
        i.style.setProperty('--x', Math.round(Math.cos(a) * r) + 'px');
        i.style.setProperty('--y', Math.round(Math.sin(a) * r * .8 - 40) + 'px');
        i.style.setProperty('--r', Math.round(Math.random() * 540 - 270) + 'deg');
        i.style.setProperty('--c', colors[k % colors.length]);
        i.style.setProperty('--d', (Math.random() * .12).toFixed(2) + 's');
        if (k % 3 === 0) i.style.borderRadius = '50%';
        burst.appendChild(i);
      }
      setTimeout(function () { burst.innerHTML = ''; }, 1600);
    }
    function finish() {
      finished = true;
      root.classList.add('is-complete');
      go(cur, true);
      done.hidden = false;
      pop();
      setTimeout(function () { root.classList.remove('is-complete'); }, 1700);
    }
    function restart() {
      finished = false; done.hidden = true;
      go(0, true);
      $('.gd__btn', steps[0]).focus();
    }
    function stopAuto() { clearTimeout(timer); auto = false; root.classList.remove('is-auto'); }
    function tick() {
      if (!auto) return;
      if (cur >= steps.length - 1) { stopAuto(); return; }
      timer = setTimeout(function () { if (!auto) return; go(cur + 1); tick(); }, GUIDE_STEP);
    }

    steps.forEach(function (s, k) { $('.gd__btn', s).addEventListener('click', function () { go(k, true); }); });
    prev.addEventListener('click', function () { go(cur - 1, true); });
    next.addEventListener('click', function () { if (cur === steps.length - 1) finish(); else go(cur + 1, true); });
    if (again) again.addEventListener('click', restart);
    ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, function () { if (auto) stopAuto(); }, { passive: true }); });
    seen(root, function (vis) {
      root.__visible = vis;
      if (vis) {
        loadVideo(frameFor(cur));
        if (auto) { clearTimeout(timer); root.classList.add('is-auto'); go(cur); tick(); }
      } else {
        $$('video', root).forEach(function (v) { if (!v.paused) v.pause(); });
        // off screen the steps wait; they go on from the same step when the guide is back in view
        clearTimeout(timer); root.classList.remove('is-auto');
      }
    }, 0.45);

    root.__select = function (blockId) { steps.forEach(function (s, k) { if (s.getAttribute('data-block') === blockId) go(k, true); }); };
    go(0);
  }

  /* -------------------------------------------------------------------------------------------------
     3. Product info tabs (ARIA tabs: arrows, Home and End move between tabs) and the tilting stage.
  ------------------------------------------------------------------------------------------------- */
  function initInfo(root) {
    if (root.__pi) return; root.__pi = 1;
    var list = $('[data-pi-list]', root), tabs = $$('[role="tab"]', root), ink = $('[data-pi-ink]', root);
    function placeInk() {
      var t = tabs.filter(function (x) { return x.getAttribute('aria-selected') === 'true'; })[0];
      if (!t || !ink) return;
      ink.style.setProperty('--w', t.offsetWidth + 'px');
      ink.style.setProperty('--x', t.offsetLeft + 'px');
    }
    function sel(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i, p = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) t.removeAttribute('tabindex'); else t.setAttribute('tabindex', '-1');
        if (p) p.hidden = !on;
      });
      if (focus) tabs[i].focus();
      tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: still() ? 'auto' : 'smooth' });
      placeInk();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { sel(i, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = tabs.length, j = -1;
        if (k === 'ArrowRight') j = (i + 1) % n; else if (k === 'ArrowLeft') j = (i - 1 + n) % n; else if (k === 'Home') j = 0; else if (k === 'End') j = n - 1;
        if (j > -1) { e.preventDefault(); sel(j, true); }
      });
    });
    if (list && ink) {
      placeInk();
      if ('ResizeObserver' in window) new ResizeObserver(placeInk).observe(list);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeInk);
    }
    root.__select = function (blockId) { tabs.forEach(function (t, k) { if (t.getAttribute('data-block') === blockId) sel(k, false); }); };
    tilt($('[data-tilt]', root), $('.pi__img', root));
  }
  function tilt(area, target) {
    if (!area || !target || !window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    area.addEventListener('pointermove', function (e) {
      if (still()) return;
      var r = area.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      target.style.setProperty('--tx', (x * 14).toFixed(2) + 'deg');
      target.style.setProperty('--ty', (y * -10).toFixed(2) + 'deg');
    });
    area.addEventListener('pointerleave', function () { target.style.setProperty('--tx', '0deg'); target.style.setProperty('--ty', '0deg'); });
  }

  /* -------------------------------------------------------------------------------------------------
     4. Banner: the light and the product follow the pointer a little; chips rise in on view.
  ------------------------------------------------------------------------------------------------- */
  function initBanner(root) {
    if (root.__bn) return; root.__bn = 1;
    seen(root, function (vis) { if (vis) root.classList.add('is-in'); }, 0.3);
    if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var raf = 0, mx = 0, my = 0;
    root.addEventListener('pointermove', function (e) {
      if (still()) return;
      var r = root.getBoundingClientRect();
      mx = ((e.clientX - r.left) / r.width - .5) * 2; my = ((e.clientY - r.top) / r.height - .5) * 2;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; root.style.setProperty('--mx', mx.toFixed(3)); root.style.setProperty('--my', my.toFixed(3)); });
    });
    root.addEventListener('pointerleave', function () { root.style.setProperty('--mx', 0); root.style.setProperty('--my', 0); });
  }

  /* -------------------------------------------------------------------------------------------------
     5. Scrolling ribbon: pause button (WCAG 2.2.2), and it rests while off screen.
  ------------------------------------------------------------------------------------------------- */
  function initTicker(root) {
    if (root.__tk) return; root.__tk = 1;
    var b = $('[data-tk-pause]', root), track = $('.tk__track', root), user = false;
    if (b) b.addEventListener('click', function () {
      user = !root.classList.contains('is-paused');
      root.classList.toggle('is-paused', user);
      b.setAttribute('aria-pressed', user ? 'true' : 'false');
      b.setAttribute('aria-label', user ? 'Play the moving text' : 'Pause the moving text');
    });
    seen(root, function (vis) { if (track) track.style.animationPlayState = (vis && !user) ? '' : 'paused'; }, 0);
  }

  /* -------------------------------------------------------------------------------------------------
     5b. Product matchmaker: one chip pressed at a time; its product slides in, the last one slides out.
  ------------------------------------------------------------------------------------------------- */
  function initMatch(root) {
    if (root.__mm) return; root.__mm = 1;
    var chips = $$('[data-mm-chip]', root), cards = $$('[data-mm-card]', root);
    if (!chips.length) return;
    root.classList.add('is-picked');
    function pick(i) {
      chips.forEach(function (c, k) { c.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      cards.forEach(function (c, k) {
        var on = k === i, was = c.classList.contains('is-on');
        if (on) { c.hidden = false; c.classList.remove('is-out'); void c.offsetWidth; c.classList.add('is-on'); }
        else if (was) {
          c.classList.remove('is-on'); c.classList.add('is-out');
          setTimeout(function () { if (!c.classList.contains('is-on')) { c.hidden = true; c.classList.remove('is-out'); } }, still() ? 0 : 600);
        }
      });
    }
    chips.forEach(function (c, k) { c.addEventListener('click', function () { pick(k); }); });
    root.__select = function (blockId) { chips.forEach(function (c, k) { if (c.getAttribute('data-block') === blockId) pick(k); }); };
  }

  /* -------------------------------------------------------------------------------------------------
     5c. Customer stories: the featured slider (moves on by itself while in view, pause button, stops for
         good once the visitor uses it), topic chips that filter the wall, and Read the full story buttons.
  ------------------------------------------------------------------------------------------------- */
  var STORY_STEP = 8000;
  function initStories(root) {
    if (root.__st) return; root.__st = 1;
    root.style.setProperty('--st-dur', STORY_STEP + 'ms');
    // No autoplay by default (premium bar: nothing moves on its own); data-st-autoplay on the section brings it back.
    var slides = $$('[data-st-slide]', root), dots = $$('.st__dots i', root), cur = 0, timer = 0, auto = slides.length > 1 && !still() && !design() && root.hasAttribute('data-st-autoplay'), user = false;
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { var on = k === cur; s.classList.toggle('is-on', on); if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
      dots.forEach(function (d, k) { d.classList.remove('is-on'); if (k === cur) { void d.offsetWidth; d.classList.add('is-on'); } });
    }
    function run() { clearTimeout(timer); if (!auto || root.classList.contains('is-paused')) return; timer = setTimeout(function () { show(cur + 1); run(); }, STORY_STEP); }
    function stop() { user = true; auto = false; clearTimeout(timer); root.classList.remove('is-auto'); }
    var prev = $('[data-st-prev]', root), next = $('[data-st-next]', root), pause = $('[data-st-pause]', root);
    if (prev) prev.addEventListener('click', function () { stop(); show(cur - 1); });
    if (next) next.addEventListener('click', function () { stop(); show(cur + 1); });
    if (pause) {
      if (!auto) pause.hidden = true;
      pause.addEventListener('click', function () {
        var p = !root.classList.contains('is-paused');
        root.classList.toggle('is-paused', p);
        pause.setAttribute('aria-label', p ? 'Play the stories' : 'Pause the stories');
        if (!p) { show(cur); run(); } else clearTimeout(timer);
      });
    }
    var feat = $('[data-st-feat]', root);
    if (feat && auto) {
      seen(feat, function (vis) {
        if (vis && auto && !user) { root.classList.add('is-auto'); show(cur); run(); }
        else { clearTimeout(timer); }
      }, 0.4);
      feat.addEventListener('focusin', function () { clearTimeout(timer); });
    }

    var chips = $$('[data-st-topic]', root), cards = $$('.st__card', root), status = $('[data-st-status]', root);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var t = c.getAttribute('data-st-topic'), n = 0;
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        cards.forEach(function (card, k) {
          var on = !t || (' ' + card.getAttribute('data-st-topics') + ' ').indexOf(' ' + t + ' ') > -1;
          card.classList.toggle('is-hidden', !on);
          if (on) { card.style.setProperty('--i', n % 6); card.style.animation = 'none'; void card.offsetWidth; card.style.animation = ''; n++; }
        });
        if (status) status.textContent = n + (n === 1 ? ' story' : ' stories');
      });
    });
    $$('[data-st-more]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var card = b.closest('.st__card'), open = !card.classList.contains('is-open');
        card.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        $('[data-open]', b).hidden = open; $('[data-close]', b).hidden = !open;
      });
    });
  }

  /* Country and currency: changing the country sends Shopify's localization form at once */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-country-select]');
    if (s && s.form) s.form.submit();
  });

  /* -------------------------------------------------------------------------------------------------
     6. Copy a discount code.
  ------------------------------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-copy]');
    if (!b) return;
    var code = b.getAttribute('data-copy'), label = $('[data-copy-label]', b), was = label ? label.textContent : '';
    function ok() { if (label) { label.textContent = b.getAttribute('data-done') || 'Copied'; setTimeout(function () { label.textContent = was; }, 2200); } }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, ok);
    else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (er) {} t.remove(); ok(); }
  });

  /* -------------------------------------------------------------------------------------------------
     7. Content pages: the search box over resource lists, and a reading bar on long text pages.
  ------------------------------------------------------------------------------------------------- */
  function initResSearch(box) {
    if (box.__rs) return; box.__rs = 1;
    var input = $('[data-res-input]', box), none = $('[data-res-none]', box);
    var list = box.parentNode.querySelector('[data-res-list]'); if (!input || !list) return;
    var items = $$('.res__item', list);
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase(), n = 0;
      items.forEach(function (it) { var on = !q || it.textContent.toLowerCase().indexOf(q) > -1; it.classList.toggle('is-hidden', !on); if (on) n++; });
      if (none) none.hidden = n > 0;
    });
  }
  function readBar() {
    var prose = $$('.textch .prose').filter(function (p) { return p.textContent.length > 2500; })[0];
    if (!prose || $('.lk-readbar')) return;
    var bar = document.createElement('div'); bar.className = 'lk-readbar'; bar.setAttribute('aria-hidden', 'true'); bar.appendChild(document.createElement('i'));
    document.body.appendChild(bar);
    var raf = 0;
    function upd() { raf = 0; var r = prose.getBoundingClientRect(), total = r.height - innerHeight * 0.6; bar.style.setProperty('--p', Math.max(0, Math.min(1, -r.top / Math.max(1, total))).toFixed(3)); }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
    upd();
  }

  /* App screenshots open full size: tap or press Enter on a phone shot; Escape, the button or a tap outside closes */
  function initZoomShots(scope) {
    $$('.shot--phone', scope).forEach(function (shot) {
      var img = $('img', shot);
      if (!img || shot.__zs) return; shot.__zs = 1;
      shot.classList.add('is-zoomable'); shot.setAttribute('role', 'button'); shot.tabIndex = 0;
      shot.setAttribute('aria-label', 'Enlarge: ' + (img.alt || 'App screen'));
      var hint = document.createElement('span'); hint.className = 'shot__zoom'; hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 20 20M10.5 7.5v6M7.5 10.5h6"/></svg>';
      shot.appendChild(hint);
      function open() {
        var box = document.createElement('div'); box.className = 'zoomshot'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', img.alt || 'App screen');
        var big = new Image(); big.alt = img.alt || ''; big.src = img.currentSrc || img.src;
        if (img.srcset) { big.srcset = img.srcset; big.sizes = '520px'; }
        var close = document.createElement('button'); close.type = 'button'; close.textContent = 'Close';
        box.appendChild(big); box.appendChild(close); document.body.appendChild(box); close.focus();
        function shut() { box.remove(); document.removeEventListener('keydown', key); shot.focus(); }
        function key(e) { if (e.key === 'Escape') shut(); }
        box.addEventListener('click', function (e) { if (e.target !== big) shut(); });
        document.addEventListener('keydown', key);
      }
      shot.addEventListener('click', open);
      shot.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
  }
  function boot(scope) {
    $$('[data-vd]', scope).forEach(initVideos);
    $$('[data-gd]', scope).forEach(initGuide);
    $$('[data-pi]', scope).forEach(initInfo);
    $$('[data-bn]', scope).forEach(initBanner);
    $$('[data-tk]', scope).forEach(initTicker);
    $$('[data-mm]', scope).forEach(initMatch);
    $$('[data-st]', scope).forEach(initStories);
    $$('[data-res-search]', scope).forEach(initResSearch);
    readBar();
    initZoomShots(scope);
  }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var host = e.target.closest('[data-vd], [data-gd], [data-pi], [data-mm]') || $('[data-vd], [data-gd], [data-pi], [data-mm]', e.target.closest('.shopify-section') || e.target);
    var id = e.detail && e.detail.blockId;
    if (host && host.__select && id) host.__select(id);
  });
})();
